import React from "react";
import { Helmet } from "react-helmet";

import { JobAdBox, LoadingIndicator } from "components";
import Constants from "app_constants";
import Theme from "./theme";

const CategoryView = ({ jobs, category, paginate, loaded }) => {
  return (
    <Theme>
      {category && (
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`Remote ${Constants.jobCategories[category]} Jobs`}</title>
        </Helmet>
      )}
      {loaded ? (
        <>
          <h3 className="category title is-3">{`${Constants.jobCategories[category]} Jobs`}</h3>

          <div className="columns is-multiline">
            {jobs.map(
              (jobAd, index) =>
                jobAd.published && (
                  <div className="column is-full" key={index.toString()}>
                    <JobAdBox jobAd={jobAd} index={index} />
                  </div>
                )
            )}
          </div>

          {jobs.length === 0 && (
            <p className="warning">
              <b>There isn't any result to show :(</b>
            </p>
          )}

          {jobs.length !== 0 && (
            <div className="loadMore">
              <button className="button" onClick={paginate}>
                Load More
              </button>
            </div>
          )}
        </>
      ) : (
        <LoadingIndicator />
      )}
    </Theme>
  );
};

export default CategoryView;
